import { UserPreferenceName } from '../constants';
import { UserPreferences } from '../types';
import { useUserPreferencesStore } from './useUserPreferencesStore';

/**
 * @description wrapper around the preference store its getPreference action. Serves no real purpose other than avoiding verbosity
 */
export const getUserPreference = <T extends UserPreferenceName>(name: T): UserPreferences[T] =>
  useUserPreferencesStore.getState().getPreference(name);
